module.exports = {"header":{"actions":{"download":{"filename":"invoice"}},"top-left":{"checked":"Business information has been successfully verified","unchecked":"Business information has not been verified","error":{"address":"The business address is incorrect.","name":"The business name is incorrect.","tax":"The tax identification number does not match the business license."},"actions":{"verify":"Click to verify","loading":"Verifying"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/viewer.json
// module id = BcK4
// module chunks = 23